import styled from '@emotion/styled'
import { Flex, Text } from '@collable/ui'

const GOOGLE_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${import.meta.env.VITE_GOOGLE_CLIENT_ID}&redirect_uri=${import.meta.env.VITE_GOOGLE_REDIRECT_URL}&response_type=code&prompt=select_account&scope=email profile`

const GoogleLoginButton = () => {
  return (
    <a href={GOOGLE_AUTH_URL} style={{ width: '100%' }}>
      <Container gap={10} justifyContent="center">
        <img src="/assets/googleIcon.svg" alt="google" style={{ width: '20px', height: '20px' }} />
        <Text size="body2" fontWeight="bold" color="commonWhite">
          Google 계정으로 시작하기
        </Text>
      </Container>
    </a>
  )
}

export default GoogleLoginButton

const Container = styled(Flex)`
  width: 100%;
  height: auto;
  padding: 12px;
  border-radius: 12px;
  background-color: #131314;
  border: 1px solid ${({ theme }) => theme.common.commonBlack};
`
